<template>
  <fieldset class="rating-input" id="assign-rating">
    <div class="h3 rating-input__galaxy">
      <input :disabled="disabled" type="radio" id="star5" v-model="score" value="5" @click="updateValue(5)"><label :class="[{ 'disabled': disabled}]" for="star5" title="Great!"><i :class="[{ 'spacer': spacer }, 'fa fa-star']"></i><span class="sr-only">5 stars</span></label>
      <input :disabled="disabled" type="radio" id="star4" v-model="score" value="4" @click="updateValue(4)"><label :class="[{ 'disabled': disabled}]" for="star4" title="Good"><i :class="[{ 'spacer': spacer }, 'fa fa-star']"></i><span class="sr-only">4 stars</span></label>
      <input :disabled="disabled" type="radio" id="star3" v-model="score" value="3" @click="updateValue(3)"><label :class="[{ 'disabled': disabled}]" for="star3" title="Average"><i :class="[{ 'spacer': spacer }, 'fa fa-star']"></i><span class="sr-only">3 stars</span></label>
      <input :disabled="disabled" type="radio" id="star2" v-model="score" value="2" @click="updateValue(2)"><label :class="[{ 'disabled': disabled}]" for="star2" title="Poor"><i :class="[{ 'spacer': spacer }, 'fa fa-star']"></i><span class="sr-only">2 stars</span></label>
      <input :disabled="disabled" type="radio" id="star1" v-model="score" value="1" @click="updateValue(1)"><label :class="[{ 'disabled': disabled}]" for="star1" title="Terrible"><i :class="[{ 'spacer': spacer }, 'fa fa-star']"></i><span class="sr-only">1 star</span></label>
    </div>
  </fieldset>
</template>

<script>
  export default {
    props: {
      rating: {
        type: [Number, String]
      },
      disabled: {
        type: Boolean,
        default: false
      },
      spacer: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        score: this.rating
      }
    },
    methods: {
      updateValue: function (e) {
        if (!this.disabled) {
          this.score = Number(e)
          this.$emit('input', this.score)
        }
      }
    }
  }
</script>
<style scoped>
  *:focus {
    outline: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/FormRating.vue